
import Vue from 'vue';
import { vueProp } from '../lib/vue';

export default Vue.extend({
	name: 'AppButton',
	props: {
		secondary: vueProp(Boolean, false),
		outline: vueProp(Boolean, false),
		danger: vueProp(Boolean, false),
		link: vueProp(Boolean, false),
		icon: vueProp(String, ''),
		massive: vueProp(Boolean, false),
	},
	computed: {
		classes() {
			const classes = ['btn'];

			// This is all madness and needs to be rewritten completely.
			if (this.outline) {
				classes.push('btn-outline');
			} else if (this.secondary) {
				classes.push('btn-secondary');
			} else if (this.danger) {
				classes.push('btn-danger');
			} else if (this.link) {
				classes.push('btn-link');
			} else {
				classes.push('btn-primary');
			}

			if (this.massive) {
				classes.push('btn-massive');
			}

			return classes;
		},
	},
});
